import React from 'react';
import { Modal, Button, message as AntdMessage, Row, Col, Upload, Icon, message } from 'antd';
import styles from '../style/index.scss';
import { getVariantSession, LOGIN_TOKEN, hasVariant, getVariant } from '@Variant';
import { generateUrl, getSupplierCode } from '@util';
import _ from 'lodash';

class ImportModalCom extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      fileMaxSizeInfo: 1,
      fileMaxSizeName: '1MB',
      onSubmitText: '确定',
      title: '导入',
      acceptFile: ['.xlsx', '.xls'],
      fileList: [],
      successData: {},
      isSuccessTag: false,
    };
  }
  componentDidMount() {
    const { propsAcceptFile = [], isReplaceAccept = false, title } = this.props;
    const { acceptFile, title: initTitle } = this.state;
    if (isReplaceAccept) {
      this.setState({
        acceptFile: propsAcceptFile,
      });
      return;
    }
    this.setState({
      acceptFile: [...propsAcceptFile, ...acceptFile],
      title: title || initTitle,
    });

    //上传成功自动隐藏弹框并恢复Visble为true
    const { isAutoCancelModal, autoCancelModal, onClick } = this.props;
    if (isAutoCancelModal) {
      onClick();
    }
  }

  // 确定
  onSubmit = () => {
    const { changeImportVisible, onOk } = this.props;
    const { successData, isSuccessTag } = this.state;
    if (isSuccessTag) {
      onOk(successData);
      changeImportVisible();
    } else {
      AntdMessage.warning('未导入成功, 请导入正确的数据');
    }
  };

  // 取消
  onCancel = () => {
    const { changeImportVisible } = this.props;
    changeImportVisible();
  };

  // 文件上传之前做判断
  beforeUpload = info => {
    this.setState({
      fileList: [],
    });
    const {
      maxSize = 1048576, // 判断文件体积最大值, 1k == 1024b
      overSizeMessage, // 因业务需要可能会存在比较友善的提示、所以超出文件大小时增加自定义提示api
      // onResponse
    } = this.props;

    if (maxSize && _.isNumber(maxSize)) {
      if (info.size > maxSize) {
        AntdMessage.error(overSizeMessage || 'Excel文件大小不能超过1M，请修改后重新导入');
        return false;
      }
    }
  };

  // 文件上传时候的变化
  onChange = info => {
    this.setState({
      onSubmitLoading: true,
    });
    const arr = [200, 200000];

    if (info.file.status === 'error') {
      AntdMessage.error('文件上传失败');
      this.setState({
        onSubmitLoading: false,
      });
    }
    if (info.file.status === 'done') {
      const res = info.file.response;
      if (typeof res !== 'object' || !res) {
        return AntdMessage.error('系统异常');
      }

      const {
        file: {
          response: { code, message: parenetMessage },
        },
      } = info;

      // 如果文件上传成功, 但是未导入成功
      if (!arr.includes(code)) {
        // debugger;
        const { fileList } = info;
        // 如果导入的数据不符合要求,需要将导入状态改为 error
        fileList.map(item => (item.status = 'error'));
        AntdMessage.error(parenetMessage);
        this.setState({
          onSubmitLoading: false,
        });
        // return false;
      }
      let result;
      if (res?.message && res?.message === 'success') {
        result = res;
        //bbc订单管理页面 上传成功自动隐藏按钮操作
        const { isAutoCancelModal, autoCancelModal } = this.props;
        const { successData, isSuccessTag } = this.state;
        if (isAutoCancelModal) {
          autoCancelModal(successData);
        }
      } else if (res.data) {
        result = res.data;
      } else if (res.result) {
        result = res.result;
      }
      const { message, success } = result || {};
      /**
       * @params success: true[代表导入成功], false [导入失败, 需要导出报错原因]
       * @params message 信息提示,
       * @params downloadUrl 下载报错信息的地址
       */
      if (success || message === 'success') {
        AntdMessage.success('文件上传成功');
        this.setState({
          successData: res,
          isSuccessTag: true,
        });
      } else {
        this.handleExportError(res);
        const { fileList } = info;
        // 如果导入的数据不符合要求,需要将导入状态改为 error
        fileList.map(item => (item.status = 'error'));
      }
      this.setState({
        fileList: info.fileList,
        onSubmitLoading: false,
      });
    }
    if (info.file.status === 'removed') {
      this.setState({
        onSubmitLoading: false,
      });
    }
  };

  handleExportError = res => {
    const { onExprotErrorCancel, onExprotError } = this.props;
    const _this = this;

    if (res.code !== 200000) {
      if (res.data) {
        Modal.confirm({
          title: '温馨提示',
          content: `${res.result ? res.result?.message : res?.message}`,
          okText: '报错导出',
          cancelText: '我知道了',
          onOk() {
            if (onExprotError) {
              return typeof onExprotError === 'function' && onExprotError(res);
            }
            (res.data && res.data.downloadUrl) || res.data
              ? _this.downloadError(res)
              : console.error('系统异常');
          },
          onCancel() {
            typeof onExprotErrorCancel === 'function' && onExprotErrorCancel();
          },
        });
      }
    } else {
      Modal.confirm({
        title: '温馨提示',
        content: `${res?.message}`,
        okText: '我知道了',
      });
    }
  };

  // 下载导出报错的信息
  downloadError = res => {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = res.data.downloadUrl ? res.data.downloadUrl : res.data;
    a.href = url;
    a.download = '报错导出';
    a.click();
    document.body.removeChild(a);
  };
  //bbc供应商商品下载模板
  handleDownLoad = () => {
    if (this.props.downLoadType == '批量修改商品信息') {
      this.props.handleGoodsDownload();
    } else {
      this.props.handleStockDownload();
    }
  };
  render() {
    const { Visible, action, onChange, customizeInfo, downLoadType } = this.props;
    const { fileMaxSizeName, onSubmitLoading, onSubmitText, title, acceptFile, fileList } =
      this.state;
    const { data, searchParams, urlParams, replaceParams, api } = action;
    const url = _.isObject(action)
      ? generateUrl(api, searchParams, urlParams, replaceParams)
      : action;
    const uploadParams = {
      action: url,
      data,
      name: 'file',
      accept: acceptFile && acceptFile.join(','),
      headers: {
        'login-token': getVariantSession(LOGIN_TOKEN),
        'X-Requested-With': null,
        'supplier-code': getSupplierCode(),
      },
      beforeUpload: this.beforeUpload,
      onChange: onChange || this.onChange,
      // fileList,
    };

    if (fileList.length > 1) {
      uploadParams.fileList = [fileList.pop()];
    }

    return (
      <Modal
        visible={Visible}
        title={title}
        onCancel={() => this.onCancel()}
        footer={
          <div>
            <Button onClick={this.onCancel}>取消</Button>
            <Button loading={onSubmitLoading} onClick={this.onSubmit} type="primary">
              {onSubmitText}
            </Button>
          </div>
        }>
        {!this.props.isGoodsBtn ? (
          <Row span={24} className={styles.importModal}>
            <Col className={styles.leftTitile} span={4}>
              上传数据:
            </Col>
            <Col span={19}>
              <div className={styles.rightRowUplod}>
                <Upload {...uploadParams}>
                  <a>上传文件</a>
                </Upload>
              </div>
              {customizeInfo ? (
                <div className={styles.rightRow}>{customizeInfo}</div>
              ) : (
                <div className={styles.rightRow}>
                  目前仅支持{`${acceptFile.join(',')}`}格式的文件, 文件大小请控制在
                  <span style={{ color: '#f00' }}> {fileMaxSizeName} </span>
                  以内
                </div>
              )}
            </Col>
          </Row>
        ) : (
          <div className={styles.maintain}>
            <div className={styles.maintainTop}>
              <Upload {...uploadParams}>
                <div className={styles.openFile}>
                  <p className={styles.openIcon}>
                    <Icon type="plus" />
                  </p>
                  <p className={styles.selectFile}>选择文件</p>
                </div>
              </Upload>
            </div>
            <div className={styles.maintainBottom}>
              <p>支持xlsx / xls格式</p>
              <p>
                excel文件必须为
                {downLoadType == '批量维护库存' ? '批量维护库存' : '批量修改商品信息'}
                导入模板，请先
                <span className={styles.download} onClick={this.handleDownLoad}>
                  下载模板
                </span>
                编辑{downLoadType == '批量维护库存' ? '库存' : '商品信息'}后上传
              </p>
            </div>
          </div>
        )}
      </Modal>
    );
  }
}

export default ImportModalCom;
